module.exports = __webpack_public_path__ + "static/media/popupSingle.25384df5.png";